/* eslint-disable */

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Input, Button, Card, Space, Typography, Row, Col, message, Divider } from 'antd';
import {
  SaveOutlined,
  ReloadOutlined,
  SendOutlined,
  InfoCircleOutlined,
  MessageOutlined,
} from '@ant-design/icons';

const { Title, Text } = Typography;
const { TextArea } = Input;

function APISettingSMS(props) {
  const [configForm] = Form.useForm();
  const [testForm] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [testLoading, setTestLoading] = useState(false);
  const [creditLoading, setCreditLoading] = useState(false);
  const [remaining_credit, setRemaining_credit] = useState({ standard: '-', corporate: '-' });

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    api_read_smsconfig();
  }, []);

  async function api_read_smsconfig() {
    setLoading(true);
    await sleep(500);

    const formData = new FormData();
    axios
      .post(props.app_hostname + '/api/account/setting/sms/readconfig', formData, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + props.permitdata.token,
        },
      })
      .then((response) => {
        setLoading(false);
        if (response.data.status === 'OK') {
          configForm.setFieldsValue({
            'sms-config-apiurl': response.data.apidata.api_url,
            'sms-config-apikey': response.data.apidata.api_key,
            'sms-config-apisecret': response.data.apidata.api_secret,
          });
        } else {
          message.error(response.data.message || 'เกิดข้อผิดพลาดในการโหลดการตั้งค่า');
        }
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  }

  async function api_save_smsconfig(values) {
    setLoading(true);
    await sleep(500);

    const formData = new FormData();
    formData.append('sms-config-apiurl', values['sms-config-apiurl']);
    formData.append('sms-config-apikey', values['sms-config-apikey']);
    formData.append('sms-config-apisecret', values['sms-config-apisecret']);

    axios
      .post(props.app_hostname + '/api/account/setting/sms/saveconfig', formData, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + props.permitdata.token,
        },
      })
      .then((response) => {
        setLoading(false);
        if (response.data.status === 'OK') {
          configForm.setFieldsValue({
            'sms-config-apiurl': response.data.apidata.api_url,
            'sms-config-apikey': response.data.apidata.api_key,
            'sms-config-apisecret': response.data.apidata.api_secret,
          });
          message.success('บันทึกการตั้งค่า SMS สำเร็จ');
        } else {
          message.error(response.data.message || 'เกิดข้อผิดพลาดในการบันทึกการตั้งค่า');
        }
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  }

  async function api_Send_smsmessage(values) {
    setTestLoading(true);
    await sleep(500);

    const formData = new FormData();
    formData.append('sms-test-telno', values['sms-test-telno']);
    formData.append('sms-test-message', values['sms-test-message']);

    axios
      .post(props.app_hostname + '/api/account/tester/sms/sendmessage', formData, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + props.permitdata.token,
        },
      })
      .then((response) => {
        setTestLoading(false);
        if (response.data.status === 'OK') {
          testForm.setFieldsValue({
            'sms-test-result': JSON.stringify(response.data.data, undefined, 2),
          });
          message.success('ส่งข้อความทดสอบสำเร็จ');
        } else {
          message.error(response.data.message || 'เกิดข้อผิดพลาดในการส่งข้อความ');
        }
      })
      .catch((err) => {
        setTestLoading(false);
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  }

  async function api_read_smscredit() {
    setCreditLoading(true);
    await sleep(500);

    const formData = new FormData();
    axios
      .post(props.app_hostname + '/api/account/tester/sms/readcredit', formData, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + props.permitdata.token,
        },
      })
      .then((response) => {
        setCreditLoading(false);
        if (response.data.status === 'OK') {
          setRemaining_credit(response.data.credit.remaining_credit);
          message.success('อัปเดตข้อมูลเครดิตสำเร็จ');
        } else {
          message.error(response.data.message || 'เกิดข้อผิดพลาดในการตรวจสอบเครดิต');
        }
      })
      .catch((err) => {
        setCreditLoading(false);
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  }

  return (
    <div className='page-card'>
      <Space direction='vertical' size='large' style={{ width: '100%' }}>
        <Card type='inner' title='ตั้งค่า SMS'>
          <Form form={configForm} layout='vertical' onFinish={api_save_smsconfig}>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  name='sms-config-apiurl'
                  label='ที่อยู่ลิงก์ API (API URL)'
                  rules={[{ required: true, message: 'กรุณากรอกที่อยู่ลิงก์ API' }]}
                >
                  <Input placeholder='https://api.example.com' />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name='sms-config-apikey'
                  label='คีย์ API (API Key)'
                  rules={[{ required: true, message: 'กรุณากรอกคีย์ API' }]}
                >
                  <Input.Password placeholder='คีย์ API' />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name='sms-config-apisecret'
                  label='รหัสลับ API (API Secret)'
                  rules={[{ required: true, message: 'กรุณากรอกรหัสลับ API' }]}
                >
                  <Input.Password placeholder='รหัสลับ API' />
                </Form.Item>
              </Col>
            </Row>
            <Space>
              <Button type='primary' htmlType='submit' icon={<SaveOutlined />} loading={loading}>
                บันทึกการตั้งค่า
              </Button>
              <Button icon={<ReloadOutlined />} onClick={api_read_smsconfig}>
                รีเฟรช
              </Button>
            </Space>
          </Form>
        </Card>

        <Card type='inner' title='เครื่องมือทดสอบส่ง SMS'>
          <Form form={testForm} layout='vertical' onFinish={api_Send_smsmessage}>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  name='sms-test-telno'
                  label='เบอร์โทรศัพท์ผู้รับ (MSISDN)'
                  rules={[{ required: true, message: 'กรุณากรอกเบอร์โทรศัพท์' }]}
                >
                  <Input prefix={<MessageOutlined />} placeholder='0812345678' />
                </Form.Item>
                <Form.Item
                  name='sms-test-message'
                  label='ข้อความ SMS'
                  rules={[{ required: true, message: 'กรุณากรอกข้อความ SMS' }]}
                >
                  <TextArea rows={4} placeholder='พิมพ์ข้อความ SMS ที่นี่...' />
                </Form.Item>
                <Button
                  type='primary'
                  htmlType='submit'
                  icon={<SendOutlined />}
                  loading={testLoading}
                >
                  ส่งข้อความ
                </Button>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name='sms-test-result' label='ผลลัพธ์ตอบกลับจาก API (JSON)'>
                  <TextArea rows={8} readOnly style={{ fontFamily: 'monospace' }} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>

        <Card type='inner' title='ยอดเครดิต SMS คงเหลือ'>
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item label='ยอดเครดิต SMS ทั่วไป'>
                <Input value={remaining_credit.standard} readOnly />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item label='ยอดเครดิต SMS องค์กร'>
                <Input value={remaining_credit.corporate} readOnly />
              </Form.Item>
            </Col>
          </Row>
          <Button
            icon={<InfoCircleOutlined />}
            onClick={api_read_smscredit}
            loading={creditLoading}
          >
            ตรวจสอบเครดิต
          </Button>
        </Card>
      </Space>
    </div>
  );
}

export default APISettingSMS;
